import { servicingCompaniesApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const SERVICING_COMPANIES_ACTION_TYPE = createNamedActions('servicingCompanies', {
  GET_SERVICING_COMPANIES: 'GET_SERVICING_COMPANIES',
  CREATE_SERVICING_COMPANY: 'CREATE_SERVICING_COMPANY',
  EDIT_SERVICING_COMPANY: 'EDIT_SERVICING_COMPANY',
  DELETE_SERVICING_COMPANY: 'DELETE_SERVICING_COMPANY',
});

const servicingCompanySchema = new schema.Entity('data', {}, { idAttribute: 'id' });

export const getServicingCompaniesAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await servicingCompaniesApi.getServicingCompanies();

  return dispatch({
    type: SERVICING_COMPANIES_ACTION_TYPE.GET_SERVICING_COMPANIES,
    payload: normalize(data, [servicingCompanySchema]).entities.data,
  });
});

export const createServicingCompanyAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await servicingCompaniesApi.createServicingCompany(params);

  return dispatch({
    type: SERVICING_COMPANIES_ACTION_TYPE.CREATE_SERVICING_COMPANY,
    payload: data,
  });
});

export const editServicingCompanyAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await servicingCompaniesApi.editServicingCompany(params);

  return dispatch({
    type: SERVICING_COMPANIES_ACTION_TYPE.EDIT_SERVICING_COMPANY,
    payload: data,
  });
});

export const deleteServicingCompanyAction = catchAsyncActionError(params => async dispatch => {
  await servicingCompaniesApi.deleteServicingCompany(params);

  return dispatch({
    type: SERVICING_COMPANIES_ACTION_TYPE.DELETE_SERVICING_COMPANY,
    meta: params,
  });
});
